type CookieFirstRequestInput = {
  init?: RequestInit
  bearerFallbackToken?: string | null
}

export const withCookieFirstRequest = ({
  init,
  bearerFallbackToken,
}: CookieFirstRequestInput): RequestInit => {
  const headers = new Headers(init?.headers)
  const fallbackToken = typeof bearerFallbackToken === 'string' ? bearerFallbackToken.trim() : ''

  if (fallbackToken.length > 0 && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${fallbackToken}`)
  }

  return {
    ...init,
    credentials: 'include',
    headers,
  }
}
